import { CheckoutState } from '../../state';
import {
    filterAdvancedTeamTicketsAndVariants,
    filterGroupTickets,
} from '../../utils/tickets';

/**
 * Returns Array with all tickets available for group registration
 */
export const getGroupEligibleTypeTickets = (state: CheckoutState) =>
    filterAdvancedTeamTicketsAndVariants(
        state.tickets.ticketsById,
        filterGroupTickets,
    );
